import { flagFactory } from '../icon';
import Svg from './it.svg';

export default flagFactory(Svg);
